<template lang="pug">
  div.lmm-content-body-padded
    sub-header
    b-container(fluid)
      b-row
        b-col(cols="12")
          b-card.w-100(v-if="notice")
            div(slot="header") {{notice.notice_title}}
            div.notice-body(v-html="notice.notice_content")
            div.notice-action
              b-link(@click="$router.back()") {{$t('back')}}
              | &nbsp;&nbsp;&nbsp;&nbsp;
              router-link.card-link(:to="{name: 'notice'}") {{$t('list-of', {v: $t('notice')})}}
</template>

<script>
import {NoticeAPI} from '@/api'
export default {
  name: 'notice-detail',
  props: {
    pk: {
      type: [String, Number],
      required: true
    }
  },
  created () {
    NoticeAPI
      .get(`${this.pk}`)
      .then(resp => {
        this.notice = resp.data.objects[0]
      })
  },
  data () {
    return {
      notice: null
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-body {
  white-space: pre-wrap;
}
.notice-action {
  padding-top: 15px;
  border-top: 1px solid #d2d2d2;
  text-align: right;
}
</style>
